import { ALTERAR_ITINERARIO_FUTURO } from '../types'

export default function alterarItinerarioFuturo (itinerario) {
  return {
    type: ALTERAR_ITINERARIO_FUTURO,
    payload: itinerario
  }
}